import { useContext } from 'react';

import { HistogramLegendContext } from '../contexts/HistogramLegend.context.js';

export const useHistogramLegend = () => useContext(HistogramLegendContext);
